/**
 * @file Component for forecast correction factor input
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnDestroy } from '@angular/core';
import { SettingsService } from '../../settings.service';
import { AlertsService } from '../../core/alerts.service';
import { EventsService } from '../../core/event.service';
import { LocalisationService } from '../../core/localisation.service';
import { GridService } from '../../grids/grid.service';
import { ForecastService } from '../forecast.service';
import { PluginViewForecastBase, CORRECTIONS } from '../plugin-view-forecast/plugin-view-forecast.base';
import { DomainService } from '../../domain.service';
var PluginViewCorrectionsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PluginViewCorrectionsComponent, _super);
    /**
     * Creates an instance of PluginViewCorrectionsComponent.
     * @param {LocalisationService} localisationService
     * @param {ChangeDetectorRef} changeDetector
     * @param {EventsService} eventsService
     * @param {GridService} gridService
     * @param {SettingsService} settingsService
     * @param {ForecastService} forecastService
     * @param {AlertsService} alertsService
     * @memberOf PluginViewCorrectionsComponent
     */
    function PluginViewCorrectionsComponent(localisationService, changeDetector, eventsService, gridService, settingsService, forecastService, alertsService) {
        var _this = _super.call(this, localisationService, changeDetector, eventsService, gridService, settingsService, forecastService, alertsService) || this;
        _this.forecastService = forecastService;
        _this.alertsService = alertsService;
        /**
         * The names of the queries that are loaded when the plugin view refreshes.
         * @protected
         * @memberOf PluginViewCorrectionsComponent
         */
        _this.queryNames = [CORRECTIONS];
        _this.subscriptionPool.add(_this.gridService.stateChanged.subscribe(function () {
            // Because correctly input corrections are saved immediately, any unsaved changes are incorrect and should therefore be rejected.
            _this.forecastService.rejectChanges();
        }));
        return _this;
    }
    /**
     * Because correctly input corrections are saved immediately, any unsaved changes are incorrect and should therefore be rejected.
     * @memberOf PluginViewCorrectionsComponent
     */
    PluginViewCorrectionsComponent.prototype.ngOnDestroy = function () {
        this.forecastService.rejectChanges();
        _super.prototype.ngOnDestroy.call(this);
    };
    /**
     * Saves changes in the forecast domain if there are any.
     * @memberOf PluginViewCorrectionsComponent
     */
    PluginViewCorrectionsComponent.prototype.saveChanges = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.forecastService.hasChanges()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.forecastService.saveChanges(function (error) {
                                _this.changeDetector.detectChanges();
                                if (error) {
                                    if (error.entityErrors && error.entityErrors.length > 0) {
                                        _this.alertsService.createAlert('danger', 'APP.FORECAST.CORRECTION_NOT_SAVED', _this.forecastService.entityErrorInfo(error.entityErrors));
                                        return;
                                    }
                                    _this.alertsService.createAlert('danger', 'APP.FORECAST.CORRECTION_NOT_SAVED', error);
                                    return;
                                }
                                _this.alertsService.createAlert('success', 'APP.FORECAST.CORRECTION_SAVED');
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Places the correction factors.
     * @protected
     * @memberOf PluginViewCorrectionsComponent
     */
    PluginViewCorrectionsComponent.prototype.build = function () {
        var _this = this;
        var newEntities = [];
        this.gridCollections.forEach(function (gridSegment) {
            gridSegment.children.forEach(function (gridRows) {
                gridRows.children.forEach(function (gridRow) {
                    gridRow.children.forEach(function (gridColumn) {
                        var entity = _this.queryResults[CORRECTIONS].find(function (c) { return gridColumn.meta.start.startOf('day').isSame(c['Date']); });
                        if (!entity) {
                            var entityType = _this.forecastService.getEntityType('Correction');
                            entity = entityType.createEntity({
                                FunctionKey: DomainService.oidToKey(_this.selectedFunction['Oid']),
                                Date: gridColumn.meta.start.startOf('day').utc(true).toDate(),
                                Value: 1
                            });
                            _this.forecastService.addEntity(entity);
                            _this.queryResults[CORRECTIONS].push(entity);
                            newEntities.push(entity);
                        }
                        gridColumn.entity = entity;
                    });
                });
            });
        });
        if (newEntities.length > 0) {
            this.forecastService.entityManager.saveChanges();
        }
    };
    /**
     * Checkes for entity errors.
     * @param {Entity} entity The entity to check.
     * @returns {Boolean} True when entity errors found otherwise false.
     * @memberOf PluginViewCorrectionsComponent
     */
    PluginViewCorrectionsComponent.prototype.hasValidationErrors = function (entity) {
        return entity && entity.entityAspect.hasValidationErrors;
    };
    return PluginViewCorrectionsComponent;
}(PluginViewForecastBase));
export { PluginViewCorrectionsComponent };
